/**
 * Durées de validité du cache (TTL) pour les données de l'accueil
 */
export const CACHE_TTL = {
  ENCAISSE: 5 * 60 * 1000, // 5 minutes
  INDICATEURS: 5 * 60 * 1000, // 5 minutes
  CYCLES: 5 * 60 * 1000, // 5 minutes
  RECU_STATS: 2 * 60 * 1000, // 2 minutes (données plus volatiles)
} as const;

/**
 * Vérifie si le cache est encore valide
 * @param timestamp Date du dernier fetch (timestamp en ms)
 * @param ttl Durée de validité en millisecondes
 * @param cachedRegieId ID de la régie pour laquelle le cache a été créé
 * @param currentRegieId ID de la régie actuelle
 * @returns true si le cache est valide, false sinon
 */
export const isCacheValid = (
  timestamp: number | null,
  ttl: number,
  cachedRegieId: number | null,
  currentRegieId: number | undefined,
): boolean => {
  // Pas de cache ou pas de régie courante
  if (!timestamp || !currentRegieId) return false;

  // Changement de régie : cache invalide
  if (cachedRegieId !== currentRegieId) return false;

  // Vérification du TTL
  return Date.now() - timestamp < ttl;
};
